module.exports = __webpack_public_path__ + "assets/img/all_sukikamo_background.7c613395.svg";